import React, { useEffect, useState } from "react";
import { Col, Select, Row } from "antd";
// import { endpoints, apiVersion } from "../apis/endpoints";
// import axios from "axios";
import CustomInput from "../common/CustomInput";
import CustomButton from "../common/CustomButton";

const { Option } = Select;

const CascadingDropdown = ({addParkingbay}) => {
  // const [states, setStates] = useState([]);
  // const [zones, setZones] = useState([]);
  // const [districts, setDistricts] = useState([]);
  // const [tehsils, setTehsils] = useState([]);
  // const [villages, setVillages] = useState([]);

  // const [loading, setLoading] = useState({
  //   states: false,
  //   zones: false,
  //   districts: false,
  //   tehsils: false,
  //   villages: false,
  // });
  
  const [selected, setSelected] = useState({
    // stateId: null,
    // divisionId: null,
    // districtId: null,
    // tehsilId: null,
    // cityVillageId: null,
    parkingBayName: '',
    latitude: null,
    longitude: null
  });

  // Fetch States on Load
  // useEffect(() => {
  //   fetchStates();
  // }, []);

  // const fetchStates = async () => {
  //   setLoading((prev) => ({ ...prev, states: true }));
  //   try {
  //     const apiUrl = `${process.env.REACT_APP_API_BASE_URL}${apiVersion.version}${endpoints.states}`;
  //     const response = await axios.get(apiUrl);

  //     if (response.data && Array.isArray(response.data)) {
  //       setStates(response.data);
  //     } else {
  //       console.warn("Unexpected response format:", response);
  //       setStates([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching states:", error);
  //   } finally {
  //     setLoading((prev) => ({ ...prev, states: false }));
  //   }
  // };

  // const fetchZones = async (stateId) => {
  //   setLoading((prev) => ({ ...prev, zones: true }));
  //   try {
  //     const apiUrl = `${process.env.REACT_APP_API_BASE_URL}${apiVersion.version}${endpoints.divisions}`;
  //     const response = await axios.get(apiUrl);

  //     if (response.data && Array.isArray(response.data)) {
  //       setZones(response.data);
  //       resetSelections(["divisionId", "districtId", "tehsilId", "cityVillageId"]);
  //     } else {
  //       console.warn("Unexpected response format:", response);
  //       setStates([]);
  //     }
      
  //   } catch (error) {
  //     console.error("Error fetching zones:", error);
  //   } finally {
  //     setLoading((prev) => ({ ...prev, zones: false }));
  //   }
  // };

  // const fetchDistricts = async (zoneId) => {
  //   setLoading((prev) => ({ ...prev, districts: true }));
  //   try {
  //     const apiUrl = `${process.env.REACT_APP_API_BASE_URL}${apiVersion.version}${endpoints.districts}`;
  //     const response = await axios.get(apiUrl);

  //     if (response.data && Array.isArray(response.data)) {
  //       setDistricts(response.data);
  //     resetSelections(["districtId", "tehsilId", "cityVillageId"]);
  //     } else {
  //       console.warn("Unexpected response format:", response);
  //       setStates([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching districts:", error);
  //   } finally {
  //     setLoading((prev) => ({ ...prev, districts: false }));
  //   }
  // };

  // const fetchTehsils = async (districtId) => {
  //   setLoading((prev) => ({ ...prev, tehsils: true }));
  //   try {
  //     const apiUrl = `${process.env.REACT_APP_API_BASE_URL}${apiVersion.version}${endpoints.tehsils}`;
  //     const response = await axios.get(apiUrl);

  //     if (response.data && Array.isArray(response.data)) {
  //       setTehsils(response.data);
  //       resetSelections(["tehsilId", "cityVillageId"]);
  //     } else {
  //       console.warn("Unexpected response format:", response);
  //       setStates([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching tehsils:", error);
  //   } finally {
  //     setLoading((prev) => ({ ...prev, tehsils: false }));
  //   }
  // };

  // const fetchVillages = async (tehsilId) => {
  //   setLoading((prev) => ({ ...prev, villages: true }));
  //   try {
  //     const apiUrl = `${process.env.REACT_APP_API_BASE_URL}${apiVersion.version}${endpoints.cityVillage}`;
  //     const response = await axios.get(apiUrl);

  //     if (response.data && Array.isArray(response.data)) {
  //       setVillages(response.data);
  //       resetSelections(["cityVillageId"]);
  //     } else {
  //       console.warn("Unexpected response format:", response);
  //       setStates([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching villages:", error);
  //   } finally {
  //     setLoading((prev) => ({ ...prev, villages: false }));
  //   }
  // };

  const resetSelections = (fields) => {
    setSelected((prev) => ({
      ...prev,
      ...fields.reduce((acc, field) => ({ ...acc, [field]: null }), {}),
    }));
  };

  function handleAddParkingBay() {
    const requiredFields = [
      // "stateId",
      // "divisionId",
      // "districtId",
      // "tehsilId",
      // "cityVillageId",
      "parkingBayName",
      "latitude",
      "longitude"
    ];
  
    const missingFields = requiredFields.filter(
      (key) => selected[key] === null || selected[key] === ''
    );
  
    if (missingFields.length > 0) {
      alert(`Please fill all required fields: ${missingFields.join(", ")}`);
      return;
    }
  
    addParkingbay(selected);
  }
  

  return (
    <>
      <div style={{ width: "100%" }}>
        {/* First Row - State to Tehsil */}
        {/* <Row gutter={16}>
          <Col span={6}>
            <Select
              showSearch
              placeholder="Select State *"
              loading={loading.states}
              onChange={(value) => {
                setSelected((prev) => ({ ...prev, stateId: value }));
                fetchZones(value);
              }}
              value={selected.stateId}
              style={{ width: "100%" }}
            >
              {states.map((state) => (
                <Option key={state.id} value={state.id}>
                  {state.name}
                </Option>
              ))}
            </Select>
          </Col>

          <Col span={6}>
            <Select
              showSearch
              placeholder="Select Zone *"
              loading={loading.zones}
              disabled={!selected.stateId}
              onChange={(value) => {
                setSelected((prev) => ({ ...prev, divisionId: value }));
                fetchDistricts(value);
              }}
              value={selected.divisionId}
              style={{ width: "100%" }}
            >
              {zones.map((zone) => (
                <Option key={zone.id} value={zone.id}>
                  {zone.name}
                </Option>
              ))}
            </Select>
          </Col>

          <Col span={6}>
            <Select
              showSearch
              placeholder="Select District *"
              loading={loading.districts}
              disabled={!selected.divisionId}
              onChange={(value) => {
                setSelected((prev) => ({ ...prev, districtId: value }));
                fetchTehsils(value);
              }}
              value={selected.districtId}
              style={{ width: "100%" }}
            >
              {districts.map((district) => (
                <Option key={district.id} value={district.id}>
                  {district.name}
                </Option>
              ))}
            </Select>
          </Col>

          <Col span={6}>
            <Select
              showSearch
              placeholder="Select Tehsil *"
              loading={loading.tehsils}
              disabled={!selected.districtId}
              onChange={(value) => {
                setSelected((prev) => ({ ...prev, tehsilId: value }));
                fetchVillages(value);
              }}
              value={selected.tehsilId}
              style={{ width: "100%" }}
            >
              {tehsils.map((tehsil) => (
                <Option key={tehsil.id} value={tehsil.id}>
                  {tehsil.name}
                </Option>
              ))}
            </Select>
          </Col>
        </Row> */}

        <Row gutter={16} style={{ marginTop: 16 }} justify={"center"}>
          {/* <Col span={6}>
            <Select
              showSearch
              placeholder="Select Village *"
              loading={loading.villages}
              disabled={!selected.tehsilId}
              onChange={(value) => {
                setSelected((prev) => ({ ...prev, cityVillageId: value }));
              }}
              value={selected.cityVillageId}
              style={{ width: "100%" }}
            >
              {villages.map((village) => (
                <Option key={village.id} value={village.id}>
                  {village.name}
                </Option>
              ))}
            </Select>
          </Col> */}

          <Col span={6}>
            <CustomInput
              placeholder="Master Location Name *"
              value={selected?.parkingBayName}
              onChange={(e) => setSelected({ ...selected, parkingBayName: e.target.value })}
              required={true}
              requiredMessage="Master Location Name is required"
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={6}>
            <CustomInput
              placeholder="Latitude *"
              value={selected?.latitude}
              onChange={(e) => setSelected({ ...selected, latitude: e.target.value })}
              required={true}
              requiredMessage="Latitude Name is required"
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={6}>
            <CustomInput
              placeholder="Longitude *"
              value={selected?.longitude}
              onChange={(e) => setSelected({ ...selected, longitude: e.target.value })}
              required={true}
              requiredMessage="Longitude is required"
              style={{ width: "100%" }}
            />
          </Col>
        </Row>
        <Row style={{ display: "flex", justifyContent: "space-around" }}>
          <Col>
              <CustomButton
                type="primary" 
                  onClick={handleAddParkingBay} 
                  title={"Add Master Location"}
                />
            </Col>
        </Row>
      </div>
    </>

  );
};

export default CascadingDropdown;
